import React from "react";
import useFadeInOnScroll from "../hooks/useFadeInOnScroll.js";

export default function FadeSection({ children, className = "" }) {
  const { ref, isVisible } = useFadeInOnScroll();

  return (
    <div
      ref={ref}
      className={`fade-section ${isVisible ? "visible" : ""} ${className}`}
    >
      {children}
    </div>
  );
}
